module.exports = "<div class=\"tabs\">\n  <a *ngFor=\"let tab of tabs\" [routerLink]=\"tab.link\" routerLinkActive=\"active\" class=\"tab\">\n    <i class=\"ico {{tab.ico}} vam mr10\"></i>{{tab.title}}\n  </a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/shared/tabs/tabs.component.html
// module id = +2pX
// module chunks = 6